import { EmailAlertAdditionalParamsInterface } from 'common/data/email-alert/additional-params.interface';
import { PropertySearchFormLocationQueryParamsInterface } from 'common/module/property-search-form/location/query-params.interface';

export class EmailAlertAdditionalParamsAdapter {
  /**
   * Transforms property search query params into email alert additional params
   */
  public fromPropertySearchFormQueryParams(
    input: PropertySearchFormLocationQueryParamsInterface
  ): EmailAlertAdditionalParamsInterface {
    return {
      price_type_id: parseInt(input.rp, 10) || null,
      type_id: parseInt(input.t, 10) || null,
      price_min: parseInt(input.pf, 10) || null,
      price_max: parseInt(input.pt, 10) || null,
      area_min: parseInt(input.af, 10) || null,
      area_max: parseInt(input.at, 10) || null,
    };
  }
}
